import React, {useEffect} from 'react';
import BaseContainer from "../containers/common/BaseContainer";
import ResultForm from "../containers/ResultForm";
import { useRecoilValue } from "recoil";
import {userState} from "../state/globalState";


const ResultPage = ({ history }) => {
    const userInfo = useRecoilValue(userState);

    useEffect(() => {
        // if (userInfo.admnNo) {
        //     if (userInfo.surveyYn === "0") {
        //         history.push("/agree");
        //     }
        // }
    }, []);

    return (
        <>
            <BaseContainer sidebar={true}>
                <ResultForm />
            </BaseContainer>
        </>
    )
};

export default ResultPage;
